// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1ka8t","content":"styles_content__38dXk","flexButton":"styles_flexButton__1ltva"};